import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { Container } from "@mui/material";
import HtmlRender from "../../components/HtmlRender/HtmlRender";
import AppBarCustom from "../../components/AppBar";
import React from "react";
export const Page = (data) => {
    var _a, _b;
    return (_jsxs(_Fragment, { children: [_jsx(AppBarCustom, { pages: data.pages || [], navegatePage: data.navegatePage }), _jsxs(Container, { children: [_jsx(Grid, Object.assign({ container: true, style: { marginTop: 32, marginBottom: 64 } }, { children: _jsx(Typography, Object.assign({ variant: "h4", component: "h4" }, { children: (_a = data === null || data === void 0 ? void 0 : data.page) === null || _a === void 0 ? void 0 : _a.Titulo })) })), _jsx(HtmlRender, { html: ((_b = data === null || data === void 0 ? void 0 : data.page) === null || _b === void 0 ? void 0 : _b.Conteudo) || "" })] })] }));
};
